/** Join class names, dropping falsy values. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(" ");
}

/** Clamp `n` into [min, max]. */
export function clamp(n: number, min: number, max: number): number {
  return n < min ? min : n > max ? max : n;
}

/** Format milliseconds as mm:ss (or mm:ss.s when `tenths`). */
export function formatMs(ms: number, tenths = false): string {
  const total = Math.max(0, ms);
  const m = Math.floor(total / 60000);
  const s = Math.floor((total % 60000) / 1000);
  const base = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  if (!tenths) return base;
  return `${base}.${Math.floor((total % 1000) / 100)}`;
}

/** Format seconds as mm:ss. */
export const formatSec = (sec: number): string => formatMs(sec * 1000);

let seq = 0;
/** Stable-ish unique id for aria wiring when useId is unavailable. */
export function nextId(prefix = "xz"): string {
  seq += 1;
  return `${prefix}-${seq}`;
}
